import { useTranslation } from 'react-i18next';
import { Star, User } from 'lucide-react';
import type { Testimonial } from '@/types/config';
import testimonialsData from '@/data/testimonials.json';
import SectionHeading from '@/components/common/SectionHeading';

export default function Testimonials() {
  const { t, i18n } = useTranslation();
  const isHindi = i18n.language === 'hi';
  const testimonials: Testimonial[] = testimonialsData;

  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          title={t('home.testimonialsTitle')}
          subtitle={t('home.testimonialsSubtitle')}
        />

        <div className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4 scrollbar-hide">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="w-80 shrink-0 snap-start rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className={
                      i < testimonial.rating
                        ? 'fill-accent text-accent'
                        : 'text-gray-300'
                    }
                  />
                ))}
              </div>

              {/* Text */}
              <p className="mt-3 text-sm text-gray-600">
                "{isHindi ? testimonial.textHi : testimonial.text}"
              </p>

              {/* Author */}
              <div className="mt-4 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <User size={18} />
                </div>
                <span className="font-medium text-gray-900">
                  {isHindi ? testimonial.nameHi : testimonial.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
